/* External */
import {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Storage */
import { getContinueWatchingShow } from '../storage/shows';
import { selectContentById } from '../storage/contents';

/* Utils */
import useRequestAndDelete from './useRequestAndDelete';
import { PROVIDERS, STATUS_TYPES } from '../utils/constants';

const fullPatternRegex = /^[\dA-Fa-f-]{36}.+/;
const uuidRegex = /^[\dA-Fa-f-]{36}/;

export default function useFetchContinueWatchingShow(showId, sourceProvider = PROVIDERS.VRIO) {
  const dispatch = useDispatch();
  const previousRequest = useRef();
  const [requestId, setRequestId] = useState(undefined);

  const request = useRequestAndDelete(requestId);

  useEffect(() => {
    if (showId) {
      let cleanContentId = showId;

      if (fullPatternRegex.test(cleanContentId)) {
        cleanContentId = cleanContentId?.match(uuidRegex)?.[0];
      }

      const action = getContinueWatchingShow(cleanContentId);
      setRequestId(action.requestId);

      dispatch(action);
    } else {
      setRequestId(undefined);
    }
  }, [dispatch, showId]);

  if (!requestId) {
    previousRequest.current = undefined;
  } else if (request && (
    request.status === STATUS_TYPES.SUCCEED_STATE
    || request.status === STATUS_TYPES.FAILED_STATE
  )) {
    previousRequest.current = request;
  }

  const contentId = previousRequest.current?.result?.contents?.[0];
  const contentSelector = useMemo(() => selectContentById(`${contentId}-${sourceProvider}`), [contentId, sourceProvider]);
  const content = useSelector(contentSelector);

  return {
    contentId,
    content,
  };
}
